module.exports = __webpack_public_path__ + "static/media/uml.9068e597.svg";